import { render, staticRenderFns } from "./ED2022.vue?vue&type=template&id=7e2e0d70&scoped=true"
import script from "./ED2022.vue?vue&type=script&lang=js"
export * from "./ED2022.vue?vue&type=script&lang=js"
import style0 from "./ED2022.vue?vue&type=style&index=0&id=7e2e0d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e2e0d70",
  null
  
)

export default component.exports